export default "__VITE_ASSET__Dd02Jkme__"